export const PERMISSIONS = {
    INSERT: 1,
    VIEW: 2,
    EDIT: 3,
    DELETE: 4,
};